export function workerReport(state = [], action) {
    switch (action.type) {
        case 'WORKERREPORT_LIST':
        console.log(action.data);
        // action.list="yes";
            return action.data
        default:
            return state
    }
}